module.exports = __webpack_public_path__ + "img/burger.1b947a52.png";